// === POPUP CHOIX DE PSEUDO ===
// Overlay DOM injecté par-dessus le canvas pour la saisie du pseudo.
// Retourne une Promise<string> résolue avec le pseudo choisi (jamais rejetée).

/** Affiche la popup de choix de pseudo et retourne le pseudo saisi */
export function showUsernamePopup(): Promise<string> {
  return new Promise((resolve) => {
    // Fond sombre couvrant tout l'écran
    const overlay = document.createElement('div');
    overlay.style.cssText = [
      'position:fixed', 'top:0', 'left:0', 'width:100%', 'height:100%',
      'background:rgba(0,0,0,0.88)', 'z-index:9999',
      'display:flex', 'align-items:center', 'justify-content:center',
    ].join(';');

    // Bloque la propagation des events vers Phaser (qui écoute au niveau
    // document) — sinon taper Enter ou cliquer dans l'input pourrait
    // déclencher des actions en jeu (skill 1/2/3, fin de tour, etc.).
    // En bubble phase pour ne pas bloquer les enfants (input doit recevoir).
    const stopAll = (e: Event) => e.stopPropagation();
    ['keydown', 'keyup', 'keypress',
      'mousedown', 'mouseup', 'click',
      'pointerdown', 'pointerup', 'pointermove',
      'touchstart', 'touchend', 'touchmove',
      'wheel'].forEach(type => overlay.addEventListener(type, stopAll));

    // Boîte centrale
    const box = document.createElement('div');
    box.style.cssText = [
      'background:#1a1a2e', 'border:2px solid #f39c12', 'border-radius:8px',
      'padding:28px 32px', 'width:min(340px, 88vw)', 'box-sizing:border-box',
      'font-family:monospace', 'color:#ecf0f1', 'text-align:center',
    ].join(';');

    // Titre
    const title = document.createElement('div');
    title.textContent = '🏴‍☠️ Bienvenue dans Deadtide !';
    title.style.cssText = 'font-size:16px;color:#f1c40f;font-weight:bold;margin-bottom:10px;';

    // Sous-titre
    const subtitle = document.createElement('div');
    subtitle.textContent = 'Choisissez votre nom de capitaine :';
    subtitle.style.cssText = 'font-size:12px;color:#bdc3c7;margin-bottom:18px;';

    // Champ texte
    const input = document.createElement('input');
    input.type = 'text';
    input.maxLength = 24;
    input.placeholder = 'ex: Capitaine Rouillé';
    input.style.cssText = [
      'width:100%', 'box-sizing:border-box',
      'background:#0d1117', 'border:1px solid #f39c12', 'border-radius:4px',
      'color:#ecf0f1', 'font-family:monospace', 'font-size:14px',
      'padding:8px 12px', 'margin-bottom:10px', 'outline:none',
    ].join(';');

    // Message d'erreur (masqué par défaut)
    const error = document.createElement('div');
    error.textContent = 'Entrez un pseudo (2–24 caractères).';
    error.style.cssText = 'font-size:11px;color:#e74c3c;margin-bottom:12px;display:none;';

    // Bouton confirmer
    const btn = document.createElement('button');
    btn.textContent = '[ ✅ Confirmer ]';
    btn.style.cssText = [
      'background:#1a2a1a', 'border:1px solid #2ecc71', 'border-radius:4px',
      'color:#2ecc71', 'font-family:monospace', 'font-size:13px',
      'padding:8px 24px', 'cursor:pointer', 'width:100%',
    ].join(';');
    btn.addEventListener('mouseover', () => { btn.style.color = '#27ae60'; });
    btn.addEventListener('mouseout', () => { btn.style.color = '#2ecc71'; });

    const confirm = () => {
      const val = input.value.trim();
      if (val.length < 2) {
        error.style.display = 'block';
        input.focus();
        return;
      }
      overlay.remove();
      resolve(val);
    };

    btn.addEventListener('click', confirm);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') confirm();
    });

    box.appendChild(title);
    box.appendChild(subtitle);
    box.appendChild(input);
    box.appendChild(error);
    box.appendChild(btn);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    // Focus automatique sur le champ
    setTimeout(() => input.focus(), 50);
  });
}
